
import CreateDetailLayout from '@/layout/edit_layout.vue'
import CoverUpload from '@/components/cover_upload/index.vue'
import Editor from '@/components/editor/index.vue'
import UploadImg from '@/common/class/UploadImg'
import { WinpressModule } from '@/store/modules/winpress'
import { Component, Vue } from 'vue-property-decorator'
// eslint-disable-next-line
import { ElForm } from 'element-ui/types/form'
import { isString } from 'lodash'
import { IMG_HOST } from '@/config/env'
import { WinpressService } from '@/services'
import { Article } from '@/common/storage'
import { addImgHost } from '@/common/utils'

@Component({
    name: '',
    components: {
        CreateDetailLayout,
        CoverUpload,
        Editor
    }
})
export default class extends Vue {
    private isLoading = false
    private typesLoading = true
    private articleForm = {
        title: '',
        type_id: '',
        url: '',
        abstract: '',
        content: '',
        cover_img: '',
        writer: '',
        published_at: ''
    }
    private rules = {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        type_id: [{ required: true, message: '请选择分类', trigger: 'blur' }],
        published_at: [{ required: true, message: '请选择发表时间', trigger: 'blur' }],
        content: [{ required: true, validator: this.contentValidator }]
    }
    get articleTypes() {
        return WinpressModule.articleTypes
    }

    created() {
        this.$title('文章详情 | 麦媒云 - 庖丁')
    }
    async mounted() {
        await this.getArticleTypes()
        this.fetchData()
    }
    async getArticleTypes() {
        await WinpressModule.getArticleTypes()
        const matchItem = this.articleTypes.find(n => String(n.id) === this.$route.params.id)
        if (matchItem == null) {
            this.articleForm.type_id = this.articleTypes[0].id
        } else {
            this.articleForm.type_id = matchItem.id
        }
        this.typesLoading = false
    }
    async fetchData() {
        const params = { id: this.$route.params.id }
        console.log('请求参数:', params)
        console.log('路由参数:', this.$route.params)
        try {
            const result = await WinpressService.getArticleDetail(params)
            console.log('API 返回完整数据:', result)
            console.log('result.data:', result.data)
            if (result.status === 200) {
                const data = result.data
                // 处理封面图：如果已经是完整 URL 直接使用，否则拼接 IMG_HOST
                let coverImg = ''
                if (data.coverImg) {
                    coverImg = data.coverImg.includes('http') ? data.coverImg : addImgHost(data.coverImg)
                }
                // 字段映射：API camelCase → 表单 snake_case
                this.articleForm = {
                    title: data.title || '',
                    type_id: data.typeId || (data.type && data.type.id) || '',
                    url: data.url || '',
                    abstract: data.abstractContent || '',
                    content: data.content || '',
                    cover_img: coverImg,
                    writer: data.writer || '',
                    published_at: data.publishedAt || ''
                }
                console.log('表单数据:', this.articleForm)
                // 如果分类已存在 type 对象，用它的 id 覆盖默认值
                if (data.typeId) {
                    this.articleForm.type_id = data.typeId
                } else if (data.type && data.type.id) {
                    this.articleForm.type_id = data.type.id
                }
            }
        } catch (err) {
            console.error('获取详情失败:', err)
        }
    }
    contentValidator(rule: any, value: any, callback: Function) {
        if (!this.articleForm.content) {
            callback(new Error('请输入内容'))
        }
        callback()
    }
    onContentChange(value: string) {
        this.articleForm.content = value
    }
    onSubmit() {
        (this.$refs.articleForm as ElForm).validate(async isValid => {
            if (!isValid) return
            this.isLoading = true
            const imgFile = (this.$refs.coverUpload as any).getFile()
            if (isString(imgFile)) {
                this.articleForm.cover_img = imgFile
            } else {
                const result = await new UploadImg(imgFile).upload()
                if (result.error) {
                    this.isLoading = false
                    return this.$merror('封面图上传失败，请稍后再试')
                }
                this.articleForm.cover_img = IMG_HOST + result.key
            }
            await this.updateArticle()
            this.isLoading = false
        })
    }
    async updateArticle() {
        const params = {
            ...this.articleForm,
            id: this.$route.params.id
        }
        const result = await WinpressService.updateArticle(params)
        if (result.status === 200) {
            return this.$msuccess('修改成功')
        }
        this.$merror(result.message || '发生错误, 请稍后再试')
    }
    // 预览文章
    onPreviewArticle() {
        Article.set(this.articleForm.content)
        window.open('/preview/rich-text')
    }
}
